import React from 'react';
import {
  bool,
  string,
  func,
  node,
  arrayOf,
  shape
} from 'prop-types';
import {
  extend
} from '@thd-nucleus/data-sources';

import { suppliedEstimateData as dataShape } from '../constants/supplied-data-shape';
import RentalEstimateProvider from '../context/RentalEstimateContext';
import EstimateApiProvider from '../context/EstimateApiContext';

export const RentalEstimateWrapperProvider = ({
  accessories,
  updateAccessories,
  graphQlEnabled,
  pickupTime,
  returnTime,
  storeId,
  rentalCategory,
  rentalSubCategory,
  svocId,
  damageProtection,
  damageProtectionChange,
  deliveryAddress,
  suppliedEstimateData,
  hideDeposit,
  children,
  hideSuccessMsg,
  hideDue,
}) => {
  return (
    <RentalEstimateProvider
      accessories={accessories}
      updateAccessories={updateAccessories}
      graphQlEnabled={graphQlEnabled}
      pickupTime={pickupTime}
      returnTime={returnTime}
      storeId={storeId}
      rentalCategory={rentalCategory}
      rentalSubCategory={rentalSubCategory}
      svocId={svocId}
      suppliedEstimateData={suppliedEstimateData}
      damageProtection={damageProtection}
      damageProtectionChange={damageProtectionChange}
      deliveryAddress={deliveryAddress}
      hideDeposit={hideDeposit}
      hideSuccessMsg={hideSuccessMsg}
      hideDue={hideDue}
    >
      <EstimateApiProvider>
        {children}
      </EstimateApiProvider>
    </RentalEstimateProvider>

  );
};

RentalEstimateWrapperProvider.propTypes = {
  accessories: arrayOf(shape({
    id: string.isRequired,
    description: string.isRequired,
    price: string.isRequired,
    selected: bool.isRequired
  })),
  updateAccessories: func,
  graphQlEnabled: bool,
  pickupTime: string.isRequired,
  returnTime: string.isRequired,
  storeId: string,
  rentalCategory: string.isRequired,
  rentalSubCategory: string.isRequired,
  svocId: string,
  damageProtection: bool,
  damageProtectionChange: func,
  deliveryAddress: shape({
    street: string,
    city: string,
    state: string,
    zipCode: string
  }),
  suppliedEstimateData: dataShape,
  hideDeposit: bool,
  children: node.isRequired,
  hideSuccessMsg: bool,
  hideDue: bool,
};

RentalEstimateWrapperProvider.defaultProps = {
  accessories: [],
  updateAccessories: () => {},
  graphQlEnabled: false,
  svocId: null,
  damageProtection: true,
  damageProtectionChange: () => {},
  hideDeposit: false,
  suppliedEstimateData: {},
  hideSuccessMsg: false,
  storeId: null,
  deliveryAddress: null,
  hideDue: false
};

RentalEstimateWrapperProvider.dataModel = extend(EstimateApiProvider);